import React from 'react';

const AboutSection = () => {
  const aboutPoints = [
    {
      icon: (
        <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2ZM21 9V7L15 6.5V7.5C15 8.3 14.3 9 13.5 9S12 8.3 12 7.5V6L6 6.5V7.5C6 8.3 5.3 9 4.5 9S3 8.3 3 7.5V9C1.9 9 1 9.9 1 11V15C1 16.1 1.9 17 3 17V20C3 21.1 3.9 22 5 22H19C20.1 22 21 21.1 21 20V17C22.1 17 23 16.1 23 15V11C23 9.9 22.1 9 21 9Z"/>
        </svg>
      ),
      title: "Primary Water Sources",
      description: "Tamil Nadu Water Resources primarily rely on rainwater, ground water and surface water from rivers and reservoirs.",
      bgColor: "bg-blue-50",
      iconBg: "bg-blue-100",
      iconColor: "text-blue-600",
      borderColor: "border-blue-200"
    },
    {
      icon: (
        <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12,15.5A3.5,3.5 0 0,1 8.5,12A3.5,3.5 0 0,1 12,8.5A3.5,3.5 0 0,1 15.5,12A3.5,3.5 0 0,1 12,15.5M19.43,12.97C19.47,12.65 19.5,12.33 19.5,12C19.5,11.67 19.47,11.34 19.43,11L21.54,9.37C21.73,9.22 21.78,8.95 21.66,8.73L19.66,5.27C19.54,5.05 19.27,4.96 19.05,5.05L16.56,6.05C16.04,5.66 15.5,5.32 14.87,5.07L14.5,2.42C14.46,2.18 14.25,2 14,2H10C9.75,2 9.54,2.18 9.5,2.42L9.13,5.07C8.5,5.32 7.96,5.66 7.44,6.05L4.95,5.05C4.73,4.96 4.46,5.05 4.34,5.27L2.34,8.73C2.21,8.95 2.27,9.22 2.46,9.37L4.57,11C4.53,11.34 4.5,11.67 4.5,12C4.5,12.33 4.53,12.65 4.57,12.97L2.46,14.63C2.27,14.78 2.21,15.05 2.34,15.27L4.34,18.73C4.46,18.95 4.73,19.03 4.95,18.95L7.44,17.94C7.96,18.34 8.5,18.68 9.13,18.93L9.5,21.58C9.54,21.82 9.75,22 10,22H14C14.25,22 14.46,21.82 14.5,21.58L14.87,18.93C15.5,18.68 16.04,18.34 16.56,17.94L19.05,18.95C19.27,19.03 19.54,18.95 19.66,18.73L21.66,15.27C21.78,15.05 21.73,14.78 21.54,14.63L19.43,12.97Z"/>
        </svg>
      ),
      title: "Infrastructure Management",
      description: "Water Resources are managed by the structures of dams, tanks, reservoirs, channels etc.",
      bgColor: "bg-emerald-50",
      iconBg: "bg-emerald-100",
      iconColor: "text-emerald-600",
      borderColor: "border-emerald-200"
    },
    {
      icon: (
        <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M11,16.5L6.5,12L7.91,10.59L11,13.67L16.59,8.09L18,9.5L11,16.5Z"/>
        </svg>
      ),
      title: "Maintenance Priority",
      description: "Water Resources maintenance is crucial for ensuring a steady supply of clean water for various uses like drinking, agriculture and industry.",
      bgColor: "bg-orange-50",
      iconBg: "bg-orange-100",
      iconColor: "text-orange-600",
      borderColor: "border-orange-200"
    },
    {
      icon: (
        <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
          <path d="M16,4C18.2,4 20,5.8 20,8C20,10.2 18.2,12 16,12C13.8,12 12,10.2 12,8C12,5.8 13.8,4 16,4M16,5.9A2.1,2.1 0 0,0 13.9,8A2.1,2.1 0 0,0 16,10.1A2.1,2.1 0 0,0 18.1,8A2.1,2.1 0 0,0 16,5.9M16,13C18.67,13 21.3,14.14 22,15.79V20H10V15.79C10.7,14.14 13.33,13 16,13M8,12C10.2,12 12,10.2 12,8C12,5.8 10.2,4 8,4C5.8,4 4,5.8 4,8C4,10.2 5.8,12 8,12M8,13C5.33,13 0,14.34 0,17V20H9V17C9,15.9 9.66,14.93 10.5,14.3C9.44,13.5 8.72,13 8,13Z"/>
        </svg>
      ),
      title: "Community Participation",
      description: "By engaging community participation in water resources, maintenance becomes more effective, sustainable and tailored to specific regional needs.",
      bgColor: "bg-purple-50",
      iconBg: "bg-purple-100",
      iconColor: "text-purple-600",
      borderColor: "border-purple-200"
    },
    {
      icon: (
        <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
          <path d="M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M5,19V5H19V7.5H7V9.5H19V11.5H7V13.5H19V15.5H7V17.5H19V19H5Z"/>
        </svg>
      ),
      title: "Multi-Department Management",
      description: "In Tamil Nadu, Water Resources are maintained by various departments working together for comprehensive governance.",
      bgColor: "bg-indigo-50",
      iconBg: "bg-indigo-100",
      iconColor: "text-indigo-600",
      borderColor: "border-indigo-200"
    },
    {
      icon: (
        <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12H20C20,16.42 16.42,20 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C14.95,4 17.6,5.64 19.08,8.2L22,8.2V2H20.5L19.08,3.42C17,1.34 14.16,0 12,0A12,12 0 0,0 0,12A12,12 0 0,0 12,24A12,12 0 0,0 24,12A12,12 0 0,0 23.09,7H21.09C21.65,8.56 22,10.24 22,12M6.5,10L12,16L17.5,10H6.5Z"/>
        </svg>
      ),
      title: "NOC Web Portal Initiative",
      description: "The Government of Tamil Nadu decided to create a NOC-Web Portal for community participation in Water Resources, to streamline the process and promote transparency.",
      bgColor: "bg-teal-50",
      iconBg: "bg-teal-100",
      iconColor: "text-teal-600",
      borderColor: "border-teal-200"
    }
  ];

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=Poppins:wght@300;400;500;600;700&display=swap');
        
        .modern-font {
          font-family: 'Poppins', 'Inter', system-ui, sans-serif;
        }
        
        .card-hover {
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
        }
        
        .card-hover:hover {
          transform: translateY(-8px);
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.15);
        }
        
        .gradient-border {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          padding: 1px;
          border-radius: 1rem;
        }
        
        .glass-effect {
          backdrop-filter: blur(16px);
          background: rgba(255, 255, 255, 0.9);
        }
      `}</style>
      
      <section className="py-24 bg-gradient-to-br from-slate-800 via-slate-900 to-blue-900 modern-font">
        <div className="container mx-auto px-6 lg:px-12 max-w-7xl">
          {/* Header */}
          <div className="text-center mb-20">
            <div className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-blue-100 to-indigo-100 text-blue-700 rounded-full text-sm font-medium mb-6 shadow-sm">
              <div className="w-2 h-2 bg-blue-500 rounded-full mr-3 animate-pulse"></div>
              About the Application
            </div>
            <h2 className="text-5xl lg:text-6xl font-light text-white mb-8 leading-tight">
              Tamil Nadu 
              <span className="font-semibold text-blue-400"> Water Resources</span>
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-blue-400 to-indigo-400 mx-auto mb-8 rounded-full"></div>
            <p className="text-xl text-slate-300 font-light max-w-4xl mx-auto leading-relaxed">
              Comprehensive water resource management through innovative digital solutions, 
              promoting community participation and transparent governance for a sustainable future.
            </p>
          </div>

          {/* About Points Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20">
            {aboutPoints.map((point, index) => (
              <div
                key={index}
                className={`${point.bgColor} card-hover rounded-2xl p-8 border-2 ${point.borderColor} glass-effect group`}
              >
                <div className="flex flex-col items-center text-center space-y-6">
                  <div className={`w-16 h-16 ${point.iconBg} rounded-2xl flex items-center justify-center ${point.iconColor} group-hover:scale-110 transition-transform duration-300 shadow-lg`}>
                    {point.icon}
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-4 group-hover:text-gray-800 transition-colors">
                      {point.title}
                    </h3>
                    <p className="text-gray-700 font-light leading-relaxed text-sm">
                      {point.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Mission Statement */}
          <div className="text-center">
            <div className="gradient-border">
              <div className="bg-gradient-to-br from-blue-600 via-blue-700 to-indigo-700 rounded-2xl p-12 lg:p-16 text-white relative overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-r from-blue-600/20 to-purple-600/20 opacity-50"></div>
                <div className="relative z-10">
                  <div className="inline-flex items-center px-4 py-2 bg-white/20 rounded-full text-sm font-medium mb-6">
                    <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    Our Mission
                  </div>
                  <h3 className="text-3xl lg:text-4xl font-light mb-6 leading-tight">
                    Building the Future of 
                    <span className="font-semibold"> Water Governance</span>
                  </h3>
                  <p className="text-xl font-light leading-relaxed max-w-5xl mx-auto opacity-95">
                    To streamline water resource management processes, promote transparency, 
                    and increase community participation through our comprehensive NOC Web Portal, 
                    ensuring sustainable water resource governance for Tamil Nadu's future generations.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutSection;